import React from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "../lib/useSettings";

export const WhatsAppButton = () => {
  const s = useSettings();
  if (!s.whatsapp) return null;
  return (
    <a
      href={`https://wa.me/${s.whatsapp}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-200"
      aria-label="WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
};
